import './components/com-avl-cal-awakening-selector/com-avl-cal-awakening-selector.js';
import './components/com-avl-cal-awakening-calendar/com-avl-cal-awakening-calendar.js';
import './components/com-avl-cal-awakening-information/com-avl-cal-awakening-information.js';